import React, { ElementType, ReactElement } from 'react';

export type ReactElementConstructor = () => ReactElement;
export type ElementOrRender = ElementType | ReactElementConstructor;

/**
 * Returns a React component from an ElementOrRender type. The ElementOrRender type
 * supports either passing a component type directly:
 *
 * property={Component}
 *
 * Or passing a no-arg function that will be called to return a constructed component:
 *
 * property={() => <Component />}
 *
 * This figures out which is passed and properly instantiates and returns it. No properties are
 * applied to the components as currently there is no need for such.
 *
 * @param elementOrRender
 */
export function elementOrRenderComponent(
  elementOrRender: ElementOrRender | null | undefined,
): ReactElement<any, any> | null {
  if (!elementOrRender) {
    return null;
  }
  if (typeof elementOrRender === 'function') {
    // this cast is annoying but TypeScript doesn't seem to recognize that since
    // this is a function it can't be ElementType
    // https://github.com/microsoft/TypeScript/issues/37663
    return (elementOrRender as ReactElementConstructor)();
  }
  // JSX thinks the tag is a native tag unless it's capitalized
  const ElementOrRender = elementOrRender;
  return <ElementOrRender />;
}
